import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { UserContext } from '../../user/UserContext';
import { logoutConnectedUser } from '../../user/userUtils';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { NavUserDecision } from './components/NavUserDecision';
import { NavUserReferral } from './components/NavUserReferral';
import { NavUserLawyer } from './components/NavUserLawyer';
import { NewChip } from '../../components/chips/NewChip';

type Props = {
  showNav: boolean;
};

const dropdownAnalytics = (source: string) => () => {
  doctrineAnalytics('Nav DropdownItemClicked', { id: source });
};

export const NavUserDropdown: FC<Props> = ({ showNav }) => {
  const { currentUser } = useContext(UserContext);
  const userLogout = () => {
    logoutConnectedUser();
  };

  const displayDocumentAnalyzerLink = currentUser.rights.includes(
    'document_analyzer',
  );

  return (
    <div
      className={classNames('nav-user-dropdown', {
        'nav-user-dropdown--show': showNav,
      })}
    >
      <NavUserLawyer />
      <ul
        className={
          currentUser.lawyerId
            ? 'nav-user-dropdown__list'
            : 'nav-user-dropdown__list-spaced'
        }
      >
        {displayDocumentAnalyzerLink && (
          <li className="hide_on--tablet">
            <Hyperlink
              className="nav-user-dropdown__link"
              href="/document_analyzer?source=nav_dropdown"
            >
              Document Analyzer{'\u00A0'}
              <NewChip />
            </Hyperlink>
          </li>
        )}
        <li className="show_on--tablet">
          <Hyperlink
            className="nav-user-dropdown__link"
            href="/dossiers?source=nav_dropdown"
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/1" />
          </Hyperlink>
        </li>
        <NavUserDecision />
        <li>
          <Hyperlink
            className="nav-user-dropdown__link"
            href="/historique_recherches?source=nav_dropdown"
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/2" />
          </Hyperlink>
        </li>
        <li>
          <Hyperlink
            className="nav-user-dropdown__link"
            href="/aide?source=nav_dropdown"
            target="_blank"
            onClick={dropdownAnalytics('help-center')}
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/3" />
          </Hyperlink>
        </li>
        <li>
          <hr className="nav-user-dropdown__separator" />
        </li>
        <NavUserReferral />
        <li>
          <Hyperlink
            className="nav-user-dropdown__link"
            href="/compte/general?source=nav_dropdown"
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/4" />
          </Hyperlink>
        </li>

        <li>
          <Hyperlink
            name="logout-link"
            className="nav-user-dropdown__link"
            onClick={userLogout}
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/5" />
          </Hyperlink>
        </li>
      </ul>
    </div>
  );
};
